<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">This book exists only because of the generous cooperation and assistance of the Drew County Historical Society, the Taylor Library at the University of Arkansas at Monticello (UAM), the Monticello Branch Library, fire chief Eric Chism, Mary Heady, Commercial Bank, Vicki Ross, Mike Pomeroy, Dr. Kate Stewart, Dr. Carole Martin, and Dr. Peggy Doss, chancellor of the University of Arkansas at Monticello.</p>
<p class="para">The authors used a variety of sources in their search for historical photographs and information, including (but not exclusive to) articles from the <i>Advance Monticellonian</i>, yearbooks from Monticello High School, yearbooks from the University of Arkansas at Monticello, <i>The Encyclopedia of Arkansas,</i> interviews with long-time Monticellonians, <i>The Drew County Arkansas History of Medicine</i>, and the previous local history books <i>Images: A Pictorial History of Drew County</i> (1997), and Images of America: <i>Monticello</i> (2011).</p>
<p class="para">A heavy debt is owed to the many local historians (past and present) who have, over the years, meticulously researched, organized, and analyzed records and then written eloquently of their conclusions and findings. Special recognition is due to Dr. Donald Holley, Dr. William F. Droessler, Sheilla Lampkin, Beth Thurman, Bettye Kellum, Claudia White, Kathy Davis, Annette Vincent, Shay Gillespie, Helen Guenter, Mary Tomlinson, and Connie Mullis.</p>
<p class="para">The authors also wish to thank Amy Jarvis, their editor at Arcadia Publishing, for her patience, expertise, and guidance.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?665af836